import { useCallback, useEffect, useRef, useState } from 'react';

interface UseStickyOptions {
	threshold?: number | number[]; // Allow custom threshold
	rootMargin?: string; // Optional margin for the observer
}

export const useSticky = ({ threshold = 0, rootMargin = '0px' }: UseStickyOptions = {}) => {
	const ref = useRef<HTMLDivElement>(null);
	const [isSticky, setIsSticky] = useState(false);

	const observerCallback = useCallback(([entry]: IntersectionObserverEntry[]) => {
		setIsSticky(entry.intersectionRatio < 1);
	}, []);

	useEffect(() => {
		if (!ref.current) return;

		const observer = new IntersectionObserver(observerCallback, {
			threshold: Array.isArray(threshold) ? threshold : [threshold],
			rootMargin,
		});

		observer.observe(ref.current);

		return () => observer.disconnect();
	}, [observerCallback, threshold, rootMargin, ref.current]);

	return { ref, isSticky };
};
